let checkboxes = document.querySelectorAll('input[type="checkbox"]');

checkboxes.forEach(function (checkbox) {
    checkbox.onmousedown = function (event) {
        event.preventDefault();
    };
});